import { http, HttpResponse } from 'msw'

import type { CreateChainAgencyAddressDataParams } from '../../agency/create-chain-agency-address-data'

interface CreateChainAgencyAddressDataPayload {
  addressData: CreateChainAgencyAddressDataParams
}

interface CreateChainAgencyAddressDataPathParams {
  alphaId: string
}

export const mockCreateChainAgencyAddressData = http.post<
  CreateChainAgencyAddressDataPathParams,
  CreateChainAgencyAddressDataPayload
>(
  '/my-business/api/agency/v1/agency-chains/:alphaId/address-data',
  async ({ request }) => {
    const requestBody = await request.json()

    if (requestBody.addressData.address === 'error') {
      const error = {
        message: 'E001',
        detail: 'Algum erro',
      }

      return HttpResponse.json({ error }, { status: 400 })
    }

    return HttpResponse.json(null, { status: 200 })
  },
)
